import ufeApi from 'services/api/ufeApi';
import { CHANNELS } from 'constants/Channels';
import urlUtils from 'utils/Url';
import languageLocaleUtils from 'utils/LanguageLocale';
import javascriptUtils from 'utils/javascript';
import { MAX_STORES } from 'constants/Store';
const { buildQuery } = urlUtils;
const { buildMap } = javascriptUtils;

// https://store-aggregation-eus1-qa2.lower.internal.sephora.com/store-aggregation/swagger-ui/index.html

function getStores(token, payload) {
    const {
        latitude,
        longitude,
        radius = languageLocaleUtils.getCountrySearchRadius(),
        autoExpand = false,
        limit = MAX_STORES,
        excludeNonSephoraStores = true,
        skuId,
        biAccountId,
        anonId
    } = payload;
    const url = '/gway/v1/dotcom-sys/stores';
    const location = `${languageLocaleUtils.getCurrentLanguage().toLowerCase()}-${languageLocaleUtils.getCurrentCountry()}`;

    const queryParams = buildQuery(
        buildMap({
            latitude,
            longitude,
            radius,
            autoExpand,
            limit,
            excludeNonSephoraStores,
            ...(skuId && { skuId })
        })
    );

    const options = {
        method: 'GET',
        headers: {
            authorization: `Bearer ${token}`,
            accept: 'application/json',
            'content-type': 'application/json',
            'content-language': location,
            ...(biAccountId && { 'x-auth-bi-id': biAccountId }),
            ...(anonId && { 'x-auth-anon-id': anonId }),
            'x-requested-source': CHANNELS.RWD
        }
    };

    return ufeApi.makeRequest(url + queryParams, options).then(data => {
        return data.errorCode ? Promise.reject(data) : data;
    });
}

export default getStores;
